import DynamicField from './DynamicField';

export default DynamicField;
